/* eslint-disable */
import React from 'react'

export class PrevIcon extends React.Component {
  render() {
    return (
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path
          d="M7 13L1 7L7 1"
          stroke="#333333"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class NextIcon extends React.Component {
  render() {
    return (
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path
          d="M1 13L7 7L1 1"
          stroke="#333333"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class SendIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 21 21"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 10L20 1L11 20L9 12L1 10Z"
          stroke={this.props.color || 'rgb(90, 152, 247)'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DownloadIcon extends React.Component {
  render() {
    return (
      <svg width="10" height="11" viewBox="0 0 10 11" fill="none">
        <path
          d="M1 7.66602V8.99935C1 9.49027 1.39797 9.88824 1.88889 9.88824H8.11111C8.60203 9.88824 9 9.49027 9 8.99935V7.66602"
          stroke="#1658F3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.22217 5.44531L4.99995 7.22309L6.77772 5.44531"
          stroke="#1658F3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 1V7.22222"
          stroke="#1658F3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class LineIcon extends React.Component {
  render() {
    return (
      <svg width="20" height="2" viewBox="0 0 20 2" fill="none">
        <path
          d="M1 1H19"
          stroke={this.props.color || 'rgb(90, 152, 247)'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class BackIcon extends React.Component {
  render() {
    return (
      <svg width="18" height="14" viewBox="0 0 18 14" fill="none">
        <path
          d="M17 7H1"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 13L1 7L7 1"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class ForwardIcon extends React.Component {
  render() {
    return (
      <svg width="18" height="14" viewBox="0 0 18 14" fill="none">
        <path
          d="M1 7H17"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 13L17 7L11 1"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class ClosePopupIcon extends React.Component {
  render() {
    return (
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z"
          stroke="#616581"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.75 6.25L6.25 10.75"
          stroke="#616581"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 6.25L10.75 10.75"
          stroke="#616581"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export const CloseWidgetIcon = ({ width, height, color }) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M18 6L6 18"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MiniMazeIcon = ({ width, height, color }) => (
  <svg
    width={width || '22'}
    height={height || '22'}
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M4 14H10V20"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 10H14V4"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 10L21 3"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 21L10 14"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MaxiMazeIcon = ({ width, height, color }) => (
  <svg
    width={width || '22'}
    height={height || '22'}
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M3 15V21H9"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 9L21 3L15 3"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 3L14 10"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 21L10 14"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export class LocationIcon extends React.Component {
  render() {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <circle cx="11" cy="11" r="11" fill="#1658F3" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 10.0909C15 13.2727 11 16 11 16C11 16 7 13.2727 7 10.0909C7 7.83156 8.79086 6 11 6C13.2091 6 15 7.83156 15 10.0909V10.0909Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 11C11.5523 11 12 10.5523 12 10C12 9.44772 11.5523 9 11 9C10.4477 9 10 9.44772 10 10C10 10.5523 10.4477 11 11 11Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export const CopyIcon = props => {
  const { width, height, color } = props
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M17.1998 7.30002H9.0998C8.10569 7.30002 7.2998 8.10591 7.2998 9.10002V17.2C7.2998 18.1941 8.10569 19 9.0998 19H17.1998C18.1939 19 18.9998 18.1941 18.9998 17.2V9.10002C18.9998 8.10591 18.1939 7.30002 17.1998 7.30002Z"
        stroke={color || '#354052'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.7 12.7H2.8C2.32261 12.7 1.86477 12.5104 1.52721 12.1728C1.18964 11.8352 1 11.3774 1 10.9V2.8C1 2.32261 1.18964 1.86477 1.52721 1.52721C1.86477 1.18964 2.32261 1 2.8 1H10.9C11.3774 1 11.8352 1.18964 12.1728 1.52721C12.5104 1.86477 12.7 2.32261 12.7 2.8V3.7"
        stroke={color || '#354052'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const DeleteIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.99992 12.6667C3.99992 13.4 4.59992 14 5.33325 14H10.6666C11.3999 14 11.9999 13.4 11.9999 12.6667V4.66667H3.99992V12.6667ZM12.6666 2.66667H10.3333L9.66659 2H6.33325L5.66659 2.66667H3.33325V4H12.6666V2.66667Z"
      fill="#354052"
    />
  </svg>
)
export const WarningIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.13687 20.9999H20.1969C21.7369 20.9999 22.6969 19.3299 21.9269 17.9999L14.3969 4.98993C13.6269 3.65993 11.7069 3.65993 10.9369 4.98993L3.40687 17.9999C2.63687 19.3299 3.59687 20.9999 5.13687 20.9999ZM12.6669 13.9999C12.1169 13.9999 11.6669 13.5499 11.6669 12.9999V10.9999C11.6669 10.4499 12.1169 9.99993 12.6669 9.99993C13.2169 9.99993 13.6669 10.4499 13.6669 10.9999V12.9999C13.6669 13.5499 13.2169 13.9999 12.6669 13.9999ZM13.6669 17.9999H11.6669V15.9999H13.6669V17.9999Z"
      fill="#FF6666"
    />
  </svg>
)

export const SuccessIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3335 2C6.8135 2 2.3335 6.48 2.3335 12C2.3335 17.52 6.8135 22 12.3335 22C17.8535 22 22.3335 17.52 22.3335 12C22.3335 6.48 17.8535 2 12.3335 2Z"
      fill="#11C314"
    />
    <path
      d="M5.3335 12.0001L10.3335 17.0001L19.3335 8.00008L17.9235 6.58008L10.3335 14.1701L6.7435 10.5901L5.3335 12.0001Z"
      fill="white"
    />
  </svg>
)

export const AttachmentIcon = props => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.4403 11.05L11.2503 20.24C10.1244 21.3658 8.59747 21.9983 7.00529 21.9983C5.41311 21.9983 3.88613 21.3658 2.76029 20.24C1.63445 19.1141 1.00195 17.5872 1.00195 15.995C1.00195 14.4028 1.63445 12.8758 2.76029 11.75L11.9503 2.55998C12.7009 1.80942 13.7188 1.38776 14.7803 1.38776C15.8417 1.38776 16.8597 1.80942 17.6103 2.55998C18.3609 3.31054 18.7825 4.32852 18.7825 5.38998C18.7825 6.45144 18.3609 7.46942 17.6103 8.21998L8.41029 17.41C8.03501 17.7853 7.52602 17.9961 6.99529 17.9961C6.46456 17.9961 5.95557 17.7853 5.58029 17.41C5.20501 17.0347 4.99418 16.5257 4.99418 15.995C4.99418 15.4643 5.20501 14.9553 5.58029 14.58L14.0703 6.09998"
        stroke="#354052"
        strokeOpacity="0.7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const CrossIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
        fill="#354052"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.85355 5.14645C9.04882 5.34171 9.04882 5.65829 8.85355 5.85355L5.85355 8.85355C5.65829 9.04882 5.34171 9.04882 5.14645 8.85355C4.95118 8.65829 4.95118 8.34171 5.14645 8.14645L8.14645 5.14645C8.34171 4.95118 8.65829 4.95118 8.85355 5.14645Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.14645 5.14645C5.34171 4.95118 5.65829 4.95118 5.85355 5.14645L8.85355 8.14645C9.04882 8.34171 9.04882 8.65829 8.85355 8.85355C8.65829 9.04882 8.34171 9.04882 8.14645 8.85355L5.14645 5.85355C4.95118 5.65829 4.95118 5.34171 5.14645 5.14645Z"
        fill="white"
      />
    </svg>
  )
}

export const MinusIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 12H19"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const StatusIcon = () => (
  <svg
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="8" height="8" rx="4" fill="#11C314" />
  </svg>
)
